import { render } from "./AminoacidDialogsComponent.vue?vue&type=template&id=0501c4d4"
import script from "./AminoacidDialogsComponent.vue?vue&type=script&lang=js"
export * from "./AminoacidDialogsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QLayout from 'quasar/src/components/layout/QLayout.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QLayout});
